module.exports = __webpack_public_path__ + "img/note_2.ca59d7a.svg";